import { useDispatch, useSelector } from "react-redux";
import { useBookingTreeService } from "serviceHooks";
import { AppState } from "store";
import { addBookingTipSuggestion } from "store/actions/bookingTreeActions";

function useBookingTreeSuggestions() {
  const dispatch = useDispatch();
  const bookingTreeService = useBookingTreeService();
  const bookingTipSuggestions = useSelector((state: AppState) => state.bookingTree.bookingTipSuggestions);

  const getBookingTipSuggestions = async (invoiceId: number) => {
    const cachedBookingTipSuggestions = bookingTipSuggestions[invoiceId];
    if (cachedBookingTipSuggestions) {
      return cachedBookingTipSuggestions;
    }

    const items = await bookingTreeService.getBookingTipSuggestions(invoiceId);
    dispatch(addBookingTipSuggestion(invoiceId, items));
    return items;
  };

  return { getBookingTipSuggestions, bookingTipSuggestions };
}

export default useBookingTreeSuggestions;
